import { ReactNode } from 'react'
import { AsElementProps } from '../types'

export const AllowedInputTypes = [
  'text',
  'number',
  'email',
  'password',
  'search',
  'tel',
  'date',
  'datetime-local',
  'time',
  'url',
  'color',
] as const

export type TextInputProps = AsElementProps<
  'input',
  {
    label?: ReactNode
    name?: string
    description?: string
    error?: string
    errorDisplay?: 'border' | 'all'
    warning?: string
    children?: ReactNode
    invisibleLabel?: boolean
    // really disable the input
    disabled_?: boolean
    inputSize?: 'default' | 'large'
    fullWidth?: boolean | 'mobile-only'
    inputContainerClassName?: string
    wrapperClassName?: string
  }
>
